import { Footer } from "../components/footer";
import Transition from "../utils/Transition";
import hdkhoa from "../components/assests/keynote/hdkhoa.png";
import hvtdung from "../components/assests/keynote/hvtdung.jpg";
import soumen from "../components/assests/keynote/soumen.jpeg";
const keynotes = [
  {
    name: "Dr. Khoa Dang Hoang",
    scope: "AI in Electrical Engineering",
    title: "AI applications in power conversion systems",
    bio: "Dr. Khoa Dang Hoang received the B.Eng. and M.Sc.(Eng.) degrees from Ho Chi Minh City University of Technology (HCMUT), Ho Chi Minh City, Vietnam, in 2002 and 2005, respectively, and the Ph.D. degree from the University of Sheffield, Sheffield, United Kingdom, in 2011, all in electrical and electronics engineering. From 2011 to 2021, he was a Research Associate and then a Research and Development Engineer in the Department of Electronic and Electrical Engineering, University of Sheffield, UK. Since 2021, he is a lecturer in Electrical & Electronic Engineering at University of Huddersfield, UK. Dr. Khoa Hoang is a PEMD expert with strong track-record (11 years) on technical leading multi-million R&D industry projects. His research interests include power conversion, electrical drives, electrical machine design and analysis, electric transportation, hydrogen powertrain, energy storage, smart-house, and microgrid. ",
    img: hdkhoa,
  },
  {
    name: "Dr. Huynh Vo Trung Dung",
    scope: "AI in Telecommunications",
    title:
      "The Synergy of Blockchain and AI in 6G Networks: Opportunities, Challenges, and Prospective Pathways",
    bio: "Dr. Huynh Vo Trung Dung is a visionary at the intersection of artificial intelligence and telecommunications. With a truly global academic background—spanning Vietnam, South Korea, and a Ph.D. from Ghent University in Belgium—he brings a unique international perspective to the stage. As a researcher and lecturer at International University (VNUHCMC), Dr. Huynh focuses his work on wireless communication using Generative AI and advanced signal processing. Beyond the laboratory, he actively bridges the gap between academic research and real-world application. Driven by a passion for the future, he is the co-founder and CTO of DexTALK AIO, a startup dedicated to cultivating Vietnam’s next generation of top-tier AI and Data Science talent to thrive on the global stage.",
    img: hvtdung,
  },
  {
    name: "Dr. Soumen Banerjee",
    scope: "Deep Learning Wireless Communications",
    title: "Deep Learning and Wireless Communication Technologies for Emerging Applications",
    bio: "Dr. Soumen Banerjee is a Professor at the School of Computing and Information Technology, Eastern International University, Vietnam. He has over 25 years of experience in academia, research, and academic administration. Previously, he served as a visiting faculty member at the University of Calcutta and as the Principal of Narula Institute of Technology in India. Dr. Banerjee has published more than 100 research papers in international journals and conferences and authored over ten books. His research interests include artificial intelligence, machine learning, computer vision, biomedical engineering, and evolutionary computation. ",
    img: soumen,
  },
];

const Keynote = () => {
  return (
    <Transition>
      <div className="container mx-auto p-6 mt-[8%] ">
        <h1 className="text-4xl font-bold text-center mb-12 mb-4">
          Keynote Speakers
        </h1>
        <div className="flex flex-col gap-12">
          {keynotes.map((speaker, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-50 dark:text-gray-800 p-8 border border-gray-300 rounded-lg shadow-lg"
            >
              <div className="flex flex-col md:flex-row">
                <div className="flex justify-center w-full md:w-1/3 my-6 pl-16">
                  <img
                    src={speaker.img}
                    alt={speaker.name}
                    className="w-full h-full object-cover rounded-sm"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
                <div className="flex flex-col justify-center md:w-2/3 md:pl-16 ">
                  <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-800 mb-2 text-center md:text-left">
                    {speaker.name}
                  </h2>
                  <p className="text-lg font-bold text-blue_super_dark dark:text-gray-600 mb-2 text-center md:text-left">
                    {speaker.scope}
                  </p>
                  <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-600 mb-4 text-center md:text-left">
                    {speaker.title}
                  </h3>
                  {/* <p className="text-sm text-gray-700 dark:text-gray-600 mb-4">
                    {speaker.abstract}
                  </p> */}
                  <details
                    className="text-sm text-gray-600 dark:text-gray-500"
                    open
                  >
                    <summary className=" text-blue_super_dark">Biography</summary>
                    <p>{speaker.bio}</p>
                  </details>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </Transition>
  );
};

export default Keynote;
